import React,{useState} from "react";
import { Route, useLocation, Redirect } from "react-router-dom";
import Layout from "src/layout/CommonLayout/Layout";
import { AuthenActionCreators } from "src/store/redux/AuthenStore";
import { localJwtKey } from "src/Service/Config/ApiUrl";
import { useSelector, useDispatch } from "react-redux";
import ContentWrapper from "src/components/Commons/style/ContentWrapper";
import ContentWrapper_List from "src/components/Commons/style/ContentWrapper_List";
import { AxiosGetJson, AxiosPostJson } from "src/Service/Config/AxiosMethod";
import { useHistory } from 'react-router'
import jwt_decode from "jwt-decode";


function _CommonRoute({ component: Component, currentUser, ...rest }) {
  const history = useHistory();

  const location = useLocation();
  const dispatch = useDispatch();
  const localUserID = "vdsafdwxd31f";
  const [user, setUser] = useState([] as any)

  React.useEffect(() => {
    let token = localStorage.getItem(localJwtKey)
    if(!token){
      //https://localhost:5001/NewsApprove_Edit?mode=edit&strid=U2FsdGVkX19mBlhp1s14sh0SeaIvfuXWhrr15WCPQQEp1u50S4=
      // let params = window.location.href;
      history.push("/Login");
      // history.push("/login");
    }else{
      let decoded : any = jwt_decode(token);
      let expireDate = new Date(decoded.exp);
      let dateNow =new Date();
      if(expireDate<dateNow){
        GetUserAccount();
      }
    }
    
    // GetUserAccount();
  }, [location]);


  const GetUserAccount = async () => {
    let check: any = await AxiosGetJson("Auth/GetAccount");
      if(check){
        setUser(check)
      }
      
  }


  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <Layout {...props}>
            <ContentWrapper_List>
              <Component {...props} />
            </ContentWrapper_List>
          </Layout>
        );
      }}
    />
  );
}

export default _CommonRoute;
